import Controller from '@ember/controller';
import { service } from '@ember/service';
import type HeadDataService from 'frontend/services/head-data';
import type FlashMessageService from 'ember-cli-flash/services/flash-messages';
import type CurrentUserService from 'frontend/services/current-user';
import type CurrentChangesetService from '@triptyk/ember-utils/services/current-changeset';

// eslint-disable-next-line ember/no-controllers
export default class Application extends Controller {
  @service declare flashMessages: FlashMessageService;
  @service declare headData: HeadDataService;
  @service declare currentUser: CurrentUserService;
  @service declare currentChangeset: CurrentChangesetService;
}

declare module '@ember/controller' {
  interface Registry {
    application: Application;
  }
}
